<script>
import FormLayout from "../../router/layouts/form";
import Inline from "@/components/news/new-inline";
import Editor from "@/components/editor";
import Multiselect from "vue-multiselect";
import api from "@/services/api";

/**
 * Nav-bar Component
 */
export default {
  props: {
    resource: {
      type: Object,
    },
  },
  components: {
    Editor,
    Inline,
    FormLayout,
    Multiselect
  },
  data() {
    return {
      charCount: this.resource.body ? this.resource.body.length : 0,
      charPromoCount: this.resource.text_promo ? this.resource.text_promo.length : 0,
      types: [
        {value: 'article', text: this.$t('news.types.article')},
        {value: 'external', text: this.$t('news.types.external')},
        {value: 'video', text: this.$t('news.types.video')},
        {value: 'youtube', text: this.$t('news.types.youtube')},
        {value: 'pdf', text: this.$t('news.types.pdf')},
      ],
      published_at: null,
      stateValidated: this.resource.state,
      url_placeholder: '',
      listTags: [],
      listKeywords: []
    };
  },
  computed: {
    bodyState() {
      if (this.resource.type === 'article') {
        return true;
      }

      if (!this.resource.body) {
        return false;
      }

      if (this.resource.type === 'youtube' || this.resource.type === 'pdf') {
        return true;
      }

      return !!this.resource.body.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/);
    },
    typeState() {
      return !!this.resource.type;
    },
    validated() {
      return this.bodyState && this.typeState;
    }
  },
  methods: {
    async loadDependencies() {
      await api.get('news_tags').then((result) => {
        this.listTags = result.data.data;
      })
    },
    setCharCount({text}) {
      this.charCount = text.length - 1;
    },
    setCharPromoCount({text}) {
      this.charPromoCount = text.length - 1;
    },
    addTag(newTag) {
      this.resource.tags.push({
        color: "7E0404",
        name: newTag
      });
    },
    addKeyword(str) {
      this.resource.seo_keywords.push({
        name: str
      });
    },
    changePublishedAt(v) {
      this.resource.published_at = v;
    },
    changeStateValidated(v) {
      this.resource.state = v;
    },
    changeYoutube(v) {
      if (v.includes('youtu.be')) {
        this.resource.body = v.split('/').pop();
        return;
      }

      if (v.includes('watch?v=')) {
        this.resource.body = v.split('watch?v=').pop().split('&').shift();
      }
    },
    slugify(string) {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')

      return string.toString().toLowerCase()
          .replace(/\s+/g, '-')
          .replace(p, c => b.charAt(a.indexOf(c)))
          .replace(/&/g, '-and-')
          .replace(/[^\w-]+/g, '')
          .replace(/--+/g, '-')
          .replace(/^-+/, '')
          .replace(/-+$/, '')
    },
    formatFile(v) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.resource.body = JSON.stringify({
          name: v.name,
          content: btoa(e.target.result)
        });
      };

      reader.readAsBinaryString(v);
    },
    formatPictures(v) {
      const reader = new FileReader();
      let temp = this.resource.pictures;

      reader.onload = (e) => {
        temp.push(JSON.stringify({
          name: v.name,
          content: btoa(e.target.result)
        }));
      };

      for (const image of v) {
        reader.readAsBinaryString(image);
      }

      this.resource.pictures = temp;

      //console.dir(this.resource.pictures);
    }
  },
  watch: {
    'resource.title': function (v) {
      this.url_placeholder = this.slugify(v);
    }
  },
  created() {
    this.loadDependencies();

    if (this.resource.published_at) {
      this.published_at = this.resource.published_at.split(' ')[0];
    }
  }
};
</script>

<template>
  <form-layout @submitted="$emit('submitted')" @cancel="$emit('cancel')" :resource="resource"
               resource-name="new" :validated="validated" :formData="this.resource.type === 'pdf'">
    <template #title>
      <inline :resource="resource" variant="title"></inline>
    </template>

    <b-row class="mb-3">
      <b-col>
        <b-form-group :label="$t('news.title')" label-for="formrow-title-input" class="text-capitalize">
          <b-form-input id="formrow-title-input" type="text" v-model="resource.title"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('news.subtitle')" label-for="formrow-subtitle-input" class="text-capitalize">
          <b-form-input id="formrow-subtitle-input" type="text" v-model="resource.subtitle"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <label for="formrow-body-input-text-promo" class="text-capitalize">Texte bannière</label>
      <editor id="formrow-body-input-text-promo" v-model="resource.text_promo" @change="setCharPromoCount"></editor>
      <b-row>
        <b-col></b-col>
        <b-col style="text-align:right">
          <b-form-text>{{ this.charPromoCount }} {{ $t('general.characters') }}</b-form-text>
        </b-col>
      </b-row>
    </b-row>

    <!--<b-form-group v-if="resource.type === 'article'">
      <label for="formrow-body-input-article" class="text-capitalize">{{ $t('news.body') }}</label>
      <editor id="formrow-body-input-article" v-model="resource.body" @change="setCharCount"></editor>
      <b-row>
        <b-col>
          <b-form-text>{{ $t('news.article_text') }}</b-form-text>
        </b-col>
        <b-col style="text-align:right">
          <b-form-text>{{ this.charCount }} {{ $t('general.characters') }}</b-form-text>
        </b-col>
      </b-row>
    </b-form-group>-->

    <b-row class="mb-3">
      <b-form-group :label="$t('news.url')" label-for="formrow-url-input" class="text-capitalize">
        <b-form-input id="formrow-url-input" type="text" v-model="resource.url"
                      :placeholder="url_placeholder"></b-form-input>
      </b-form-group>
    </b-row>

    <b-row class="mb-3">
      <b-form-group :label="$t('news.published_at')" label-for="formrow-published-at-input" class="text-capitalize">
        <b-form-input id="formrow-published-at-input" type="date" v-model="published_at"
                      @change="changePublishedAt"></b-form-input>
      </b-form-group>
    </b-row>

    <b-row class="mb-3">
      <b-col>
        <b-form-group label="Description SEO" label-for="formrow-seo-description-input" class="text-capitalize">
          <b-form-input id="formrow-seo-description-input" type="text"
                        v-model="resource.seo_description"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Mots clés SEO" label-for="formrow-seo-keywords-input" class="text-capitalize">
          <multiselect id="formrow-seo-keywords-input" v-model="resource.seo_keywords" label="name" track-by="name"
                       :options="listKeywords" :show-labels="false" :multiple="true" :taggable="true" @tag="addKeyword">
            <template slot="tag" slot-scope="props">
                    <span class="badge me-2" role="button"
                          @click="props.remove(props.option)">
                      {{ props.option.name }}
                    </span>
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <label for="formrow-body-input-pictures" class="text-capitalize">Images</label>
      <b-form-file id="formrow-body-input-pictures" v-model="resource.pictures" :state="Boolean(resource.pictures)"
                   accept=".png,.jpg,.jpeg,.svg" @input="formatPictures"
                   placeholder="Choisissez un fichier ou déposez le ici..." drop-placeholder="Déposez le fichier ici..."
                   multiple></b-form-file>
    </b-row>

    <b-row class="mb-3">
      <b-col>
        <b-form-group>
          <label for="formrow-type-input" class="text-capitalize">{{ $t('news.type') }}</label>
          <b-form-select class="form-select form-select-sm me-2 text-capitalize" v-model="resource.type" size="sm"
                         :options="this.types" id="formrow-type-input" :state="typeState"></b-form-select>
          <b-form-invalid-feedback>{{ this.$t('news.invalid_type') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('general.tags')" label-for="formrow-tags" class="text-capitalize">
          <multiselect id="formrow-tags" v-model="resource.tags" :options="listTags" label="name" track-by="id"
              :show-labels="false" :multiple="true" @tag="addTag" :taggable="true">
            <template slot="tag" slot-scope="props">
                    <span class="badge me-2" :style="{ backgroundColor: '#' + props.option.color }" role="button"
                          @click="props.remove(props.option)">
                      {{ props.option.name }}
                    </span>
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <template>
      <b-row class="mb-3">
        <b-col>
          <b-form-group v-if="resource.type === 'article'">
            <label for="formrow-body-input-article" class="text-capitalize">{{ $t('news.body') }}</label>
            <editor id="formrow-body-input-article" v-model="resource.body" @change="setCharCount"></editor>
            <b-row>
              <b-col>
                <b-form-text>{{ $t('news.article_text') }}</b-form-text>
              </b-col>
              <b-col style="text-align:right">
                <b-form-text>{{ this.charCount }} {{ $t('general.characters') }}</b-form-text>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group v-else-if="resource.type === 'youtube'">
            <label for="formrow-body-input-youtube" class="text-capitalize">{{ $t('news.body') }}</label>
            <b-form-invalid-feedback>{{ this.$t('form.invalid.url') }}</b-form-invalid-feedback>
            <b-input-group>
              <div class="input-group-text">www.youtube.com/watch?v=</div>
              <b-form-input id="formrow-body-input-youtube" type="text" v-model="resource.body"
                            :state="bodyState" @change="changeYoutube"></b-form-input>
            </b-input-group>
            <b-form-text>{{ $t('news.youtube_url') }}</b-form-text>
          </b-form-group>
          <b-form-group v-else-if="resource.type === 'pdf'">
            <label for="formrow-body-input-pdf" class="text-capitalize">{{ $t('news.body') }}</label>
            <b-form-invalid-feedback>{{ this.$t('form.invalid.pdf') }}</b-form-invalid-feedback>
            <b-form-file v-model="resource.body" :state="Boolean(resource.body)" accept=".pdf" @input="formatFile"
                         placeholder="Choisissez un fichier ou déposez le ici..."
                         drop-placeholder="Déposez le fichier ici..."
            ></b-form-file>
            <b-form-text>{{ $t('news.pdf') }}</b-form-text>
          </b-form-group>
          <b-form-group v-else-if="resource.type">
            <label for="formrow-body-input-url" class="text-capitalize">{{ $t('news.body') }}</label>
            <b-form-input id="formrow-body-input-url" type="url" v-model="resource.body" :state="bodyState"
                          :placeholder="$t('general.url_link')"></b-form-input>
            <b-form-invalid-feedback>{{ this.$t('form.invalid.url') }}</b-form-invalid-feedback>
            <b-form-text v-if="resource.type === 'video'">{{ $t('news.video_url') }}</b-form-text>
            <b-form-text v-else>{{ $t('news.external_url') }}</b-form-text>
          </b-form-group>
        </b-col>
      </b-row>
    </template>

    <template #footer>
      <b-form-checkbox v-model="stateValidated" name="validated" value="validated" unchecked-value="draft"
                       @change="changeStateValidated" class="d-inline-block me-3">
        <span class="ms-2">Publier</span>
      </b-form-checkbox>
    </template>
  </form-layout>
</template>
